import { render, staticRenderFns } from "./BusinessOwnerFinalStep.vue?vue&type=template&id=0524b594&scoped=true"
import script from "./BusinessOwnerFinalStep.vue?vue&type=script&lang=js"
export * from "./BusinessOwnerFinalStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524b594",
  null
  
)

export default component.exports